// extracted by mini-css-extract-plugin
export default {"form":"Form_form__e1yzW","title":"Form_title__5gZHF","button":"Form_button__8NOIT"};